var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('div',{staticClass:"d-flex justify-center w-full"},[_c('div',{staticClass:"lottie-player",style:({'width': `${_vm.width}px`}),attrs:{"id":_vm.id}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }